module.exports = __webpack_public_path__ + "media/svg-new/check4-124a29f9.svg";